import styled from 'styled-components';
import BusinessFilter from './component';

export default styled(BusinessFilter)``;
